import { motion } from "framer-motion";
import { ArrowRight, Home, Building, Building2, Flag, Globe2 } from "lucide-react";

const STAGES = [
  { icon: Home, label: "VILLAGE", desc: "Where the idea is born", color: "#FF8800" },
  { icon: Building, label: "TOWN", desc: "First customers, first trust", color: "#00B0FF" },
  { icon: Building2, label: "CITY", desc: "Systems and scale begin", color: "#00E676" },
  { icon: Flag, label: "INDIA", desc: "A national business emerges", color: "#FF8800" },
  { icon: Globe2, label: "WORLD", desc: "Indian venture, global reach", color: "#00B0FF" },
];

export function LocalGlobal() {
  return (
    <section data-testid="local-global-section" className="relative py-20 sm:py-28 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(255,136,0,0.05),transparent_55%)] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <p className="font-mono-tech text-xs tracking-[0.35em] text-[#00B0FF] uppercase mb-4">Local to Global</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white" data-testid="local-global-headline">
            EVERY GLOBAL COMPANY <span className="text-gradient-saffron">STARTS SOMEWHERE SMALL.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">
            A small business begins in one location and expands through technology, digital
            commerce, logistics and modern business systems.
          </p>
        </motion.div>

        <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-3" data-testid="local-global-chain">
          {STAGES.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, scale: 0.7 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              className="flex flex-col lg:flex-row items-center gap-6 lg:gap-3"
              data-testid={`local-global-step-${s.label.toLowerCase()}`}
            >
              <div className="flex flex-col items-center text-center">
                <div
                  className="rounded-full glass flex items-center justify-center animate-float"
                  style={{
                    width: 68 + i * 14,
                    height: 68 + i * 14,
                    borderColor: `${s.color}55`,
                    boxShadow: `0 0 ${20 + i * 12}px ${s.color}30`,
                    animationDelay: `${i * 0.5}s`,
                  }}
                >
                  <s.icon className="w-6 h-6" style={{ color: s.color }} strokeWidth={1.8} />
                </div>
                <p className="mt-3 font-display font-bold tracking-[0.14em] text-white text-sm sm:text-base">{s.label}</p>
                <p className="text-xs text-slate-500 mt-1 max-w-[140px]">{s.desc}</p>
              </div>
              {i < STAGES.length - 1 && (
                <ArrowRight className="w-5 h-5 text-[#FF8800] rotate-90 lg:rotate-0 shrink-0" />
              )}
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 text-center font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight"
          data-testid="local-global-statement"
        >
          <span className="text-gradient-india">THINK LOCAL. BUILD IN INDIA. SCALE GLOBAL.</span>
        </motion.p>
      </div>
    </section>
  );
}
